import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class ThNgbDateParserFormatter extends NgbDateParserFormatter {
  private readonly monthShortTh = [
    'ม.ค.',
    'ก.พ.',
    'มี.ค.',
    'เม.ย.',
    'พ.ค.',
    'มิ.ย.',
    'ก.ค.',
    'ส.ค.',
    'ก.ย.',
    'ต.ค.',
    'พ.ย.',
    'ธ.ค.'
  ];

  private readonly monthLookup = new Map<string, number>(
    this.monthShortTh.map((month, index) => [month, index + 1])
  );

  override parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }

    const thaiMatch = trimmed.match(/^(\d{1,2})\s+([^\s]+)\s+(\d{4})$/);
    if (thaiMatch) {
      const day = Number(thaiMatch[1]);
      const month = this.monthLookup.get(thaiMatch[2]);
      const year = Number(thaiMatch[3]);
      if (month && this.isValidDate(year, month, day)) {
        return { year, month, day };
      }
    }

    const slashMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (slashMatch) {
      const day = Number(slashMatch[1]);
      const month = Number(slashMatch[2]);
      const year = Number(slashMatch[3]);
      if (this.isValidDate(year, month, day)) {
        return { year, month, day };
      }
    }

    return null;
  }

  override format(date: NgbDateStruct | null): string {
    if (!date) {
      return '';
    }
    const monthName = this.monthShortTh[date.month - 1];
    if (!monthName) {
      return '';
    }
    return `${date.day} ${monthName} ${date.year}`;
  }

  private isValidDate(year: number, month: number, day: number): boolean {
    if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) {
      return false;
    }
    if (month < 1 || month > 12 || day < 1 || day > 31) {
      return false;
    }
    return true;
  }
}
